import type { LegalDocument } from "./types";

export type LegalContentDocument = LegalDocument & {
  description: string;
  category: string;
};

export const LEGAL_DOCUMENTS_BASE: LegalDocument[] = [];

export const LEGAL_DOCUMENTS: LegalContentDocument[] = [];
